import type { CPU } from '../CPU';

export function opPUSH(cpu: CPU): void {
  let push_size = cpu.impl_operands[1].register_size;
  if (push_size === 1)
    push_size = 2;
  cpu.regs.sp -= push_size;
  for (let ix = cpu.impl_operands[1].register_size - 1; ix >= 0; --ix)
    cpu.mmu.write8((cpu.regs.sp + ix) >>> 0, (cpu.impl_operands[1].value >> (8 * ix)) & 0xFF);
}

export function opPUSHL(cpu: CPU): void {
  const val = cpu.impl_operands[1].value;
  if (val & 2) {
    push16(cpu, cpu.regs.elr[cpu.regs.psw & 0x03]);
  }
  if (val & 4)
    push16(cpu, cpu.regs.epsw[cpu.regs.psw & 0x03]);
  if (val & 8) {
    push16(cpu, cpu.regs.elr[0]);
  }
  if (val & 1)
    push16(cpu, cpu.regs.ea);
}

export function opPOP(cpu: CPU): void {
  const pop_size = cpu.impl_operands[0].register_size === 1 ? 2 : cpu.impl_operands[0].register_size;
  cpu.impl_operands[0].value = 0;
  for (let ix = 0; ix < cpu.impl_operands[0].register_size; ++ix)
    cpu.impl_operands[0].value |= (cpu.mmu.read8((cpu.regs.sp + ix) >>> 0)) << (8 * ix);
  cpu.regs.sp += pop_size;
}

export function opPOPL(cpu: CPU): void {
  if (cpu.impl_operands[0].value & 1)
    cpu.regs.ea = pop16(cpu);
  if (cpu.impl_operands[0].value & 8) {
    cpu.regs.elr[0] = pop16(cpu);
  }
  if (cpu.impl_operands[0].value & 4)
    cpu.regs.psw = pop16(cpu);
  if (cpu.impl_operands[0].value & 2) {
    cpu.regs.pc = pop16(cpu);
  }
}

export function push16(cpu: CPU, data: number): void {
  cpu.regs.sp -= 2;
  cpu.mmu.write8((cpu.regs.sp + 1) >>> 0, (data >> 8) & 0xFF);
  cpu.mmu.write8(cpu.regs.sp >>> 0, data & 0xFF);
}

export function pop16(cpu: CPU): number {
  const result = cpu.mmu.read8(cpu.regs.sp >>> 0) | (cpu.mmu.read8((cpu.regs.sp + 1) >>> 0) << 8);
  cpu.regs.sp += 2;
  return result;
}
